<script lang="ts">
  import { clickOutside } from "$app/attachments.svelte"
  import type { Snippet } from "svelte"

  let {
    onblur,
    editcont,
    showcont
  }: { onblur: () => void; editcont: Snippet; showcont: Snippet } = $props()

  let edit = $state(false)

  let container = $state<HTMLElement | null>(null)
</script>

{#if edit}
  <div
    bind:this={container}
    {@attach clickOutside(() => {
      edit = false
      onblur()
    })}
  >
    {#if editcont}
      {@render editcont()}
    {:else}
      Edit
    {/if}
  </div>
{:else}
  <!-- svelte-ignore a11y_click_events_have_key_events -->
  <div
    onclick={(e) => {
      e.preventDefault()
      e.stopPropagation()
      edit = true
    }}
    role="button"
    tabindex="0"
  >
    {@render showcont()}
  </div>
{/if}
